import {me} from './stores/user';
import {date_pretty} from './utils';

declare global {
    interface Window {
        qchatapi?: QChat;
        qchatready?: (cb: () => void) => void;
    }
}

interface QChat {
    onReady(cb: () => void): void;

    open(): void;

    close(): void;

    auth(authId: string, authKey: string): Promise<boolean>;

    setProps(props: {[key: string]: string | number | boolean}): void;

    createEvent(name: string, data: any): void;

    sendMessage(message: string): void;
}

export function initQChat(apiKey: string) {
    const qchatreadyCbWait: any[] = [];

    window.qchatready = function (cb: () => void) {
        if (window?.qchatapi?.onReady) {
            window.qchatapi.onReady(cb);
        } else {
            qchatreadyCbWait.push(cb);
        }
    };

    let injected = false;
    let last_auth = '';
    let last_props = '';
    me.subscribe($me => {
        if (!$me.initialized) {
            return;
        }

        const is_authorized = !!$me.qchat.authId;
        const curr_auth = $me.qchat.authId + ':' + $me.qchat.authKey;

        if (!injected) {
            const script = document.createElement('script');
            script.async = true;
            script.src = 'https://q-chat.ru/dist/widget.js';
            script.setAttribute('data-qc-api-key', apiKey);

            if ($me.qchat.authId && $me.qchat.authKey) {
                script.setAttribute('data-qc-auth-id', $me.qchat.authId);
                script.setAttribute('data-qc-auth-key', $me.qchat.authKey);
            }

            script.onload = async function () {
                window.qchatapi &&
                    window.qchatapi.onReady(() => {
                        for (const cb of qchatreadyCbWait) {
                            try {
                                cb();
                            } catch (e) {
                                console.error(e);
                            }
                        }
                    });
            };

            document.head.appendChild(script);
            injected = true;
        } else if (is_authorized && curr_auth !== last_auth) {
            window.qchatapi && window.qchatapi.auth($me.qchat.authId, $me.qchat.authKey);
        }

        last_auth = curr_auth;

        // Устанавливаем данные пользователя
        if (is_authorized) {
            const userProps: Record<string, string> = {
                name: $me.name,
                email: $me.email,
                Баланс: $me.balance.toString(),
            };

            if ($me.tariff.is_paid && $me.tariff.id !== 'guest') {
                userProps['Тариф'] = $me.tariff.title + ' / Оплачен';
                userProps['Тариф действует до'] = date_pretty($me.tariff.until);
            } else {
                userProps['Тариф'] = $me.tariff.title + ' / НЕ оплачен';
                userProps['Тариф действует до'] = '';
            }

            const curr_props = JSON.stringify(userProps);
            if (curr_props !== last_props) {
                window.qchatready &&
                    window.qchatready(() => {
                        window.qchatapi && window.qchatapi.setProps(userProps);
                    });

                last_props = curr_props;
            }
        }
    });
}
